import React from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import Button from 'src/@vymo/ui/atoms/button';
import { ReactComponent as LeftIcon } from 'src/assets/icons/left.svg';
import { ReactComponent as RightIcon } from 'src/assets/icons/right.svg';
import styles from './index.module.scss';

function CustomMonthHeader({
  'data-test-id': dataTestId = 'month-header',
  onClickYearPicker,
  date,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}: ReactDatePickerCustomHeaderProps & {
  'data-test-id'?: string;
  onClickYearPicker: () => void;
}) {
  const year = date.getFullYear();

  return (
    <div data-test-id={dataTestId} className={styles.customHeader}>
      <div
        data-test-id={`${dataTestId}-nav-left-wrapper`}
        className={styles.customHeader__nav__left}
      >
        <Button
          onClick={decreaseYear}
          type="outlined"
          rounded
          isIcon
          size="small"
          disabled={prevYearButtonDisabled}
          className={styles.customHeader__nav__left__button}
          iconProps={{
            icon: <LeftIcon />,
            iconPosition: 'left',
          }}
        />
      </div>

      <div
        data-test-id={`${dataTestId}-content-wrapper`}
        className={styles.customHeader__content}
      >
        <Button
          type="primary"
          variant="subtle"
          size="small"
          onClick={onClickYearPicker}
        >
          {year}
        </Button>
      </div>
      <div
        data-test-id={`${dataTestId}-nav-right-wrapper`}
        className={styles.customHeader__nav__right}
      >
        <Button
          onClick={increaseYear}
          disabled={nextYearButtonDisabled}
          className={styles.customHeader__nav__right__button}
          type="outlined"
          rounded
          isIcon
          size="small"
          iconProps={{
            icon: <RightIcon />,
            iconPosition: 'left',
          }}
        />
      </div>
    </div>
  );
}

export default CustomMonthHeader;
